import { useTheme } from '@mui/material';

export const PatientChartIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke, tertiary: tertiaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none">
            <path
                fill={primaryBackground}
                d="M9 23c0-8.014 0-12.02 2.27-14.51S17.193 6 24.5 6s10.96 0 13.23 2.49C40 10.98 40 14.986 40 23s0 12.02-2.27 14.51S31.807 40 24.5 40s-10.96 0-13.23-2.49C9 35.02 9 31.014 9 23Z"
                opacity={0.5}
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeWidth={1.5}
                d="M14.462 15.67h17.35M14.462 25.824h14.719M14.462 29.596h6.04"
            />
            <path
                stroke={tertiaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="m3.212 15.92 2.5 2.5 5.5-5.5M3.212 27.096l2.5 2.5 5.5-5.5"
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M7.401 8.674c.48-4.134 4.28-5.03 5.421-5.094 4.263-.365 13.554-.3 18.712 0 4.244.248 5.47 4.867 5.47 6.847.043 3.24 0 11.37 0 17.965 0 6.652-3.766 7.374-5.925 7.936 0 0-3.145.566-7.322.566-4.633 0-14.6-.263-16.356-2.4"
            />
        </svg>
    );
};
